// utils/sendToPanorama.js

let dontClickPostings = false;

export function saveClicked() {
  const parentWindow = window.parent;

  if (!parentWindow || parentWindow === window) {
    console.warn('Panorama parent frame not available.');
    return;
  }

  if (parentWindow.JSVphotostatus === 'upload') {
    dontClickPostings = true;
    parentWindow.addframe?.backhere?.();
  }
}

export function sendToPanorama(photolink) {
  const parentWindow = window.parent;

  if (!parentWindow || parentWindow === window) {
    console.warn('Panorama parent frame not available.');
    return false;
  }

  const form = document.forms.processphotos;

  if (!form) {
    console.error('processphotos form not found inside iframe.');
    return false;
  }

  parentWindow.JSVaddphotomiddle = '';

  const editormenu = parentWindow.editormenu;

  if (editormenu?.JSVoverwritephoto) {
    form.overwritephotoid.value = editormenu.JSVoverwritephoto;
    form.code.value = 'R';
  }

  if (editormenu?.JSVaddphoto) {
    form.addphotoid.value = editormenu.JSVaddphoto;
    form.code.value = 'A';
  }

  const shouldAskToAddToPreviousPost =
    !editormenu?.JSVoverwritephoto &&
    !editormenu?.JSVaddphoto &&
    parentWindow.JSVunposts === 'y' &&
    (parentWindow.JSVphotostatus !== 'upload' || parentWindow.JSVpquan < 5);

  if (shouldAskToAddToPreviousPost) {
    const addToPreviousPost = window.confirm(
      '\n\n\nWould you like to add this photo\nto a previous post without a photo?\n\nOK = Yes, add to previous post.\nCancel = No, create a new post.\n\n\n',
    );

    if (addToPreviousPost) {
      parentWindow.JSVphotostatus = '';
      parentWindow.JSVaddphotomiddle = 'y';
      editormenu?.clickpostings?.();

      parentWindow.thumbnailframe?.document
        ?.getElementById('apmsg')
        ?.style?.setProperty('display', 'inline');

      return false;
    }
  }

  parentWindow.thumbnailframe?.updatingmessage?.();

  if (editormenu) {
    editormenu.JSVoverwritephoto = '';
    editormenu.JSVaddphoto = '';
  }

  if (!dontClickPostings) {
    editormenu?.clickpostings?.();
  }

  dontClickPostings = false;

  form.id.value = parentWindow.JSVid || '';
  form.password.value = parentWindow.JSVpw || '';
  form.photocodes.value = parentWindow.JSVphotos || '';
  form.pic.value = photolink;

  form.submit();

  setTimeout(() => {
    // window.location.href = 'f2-pesdk';
    window.location.href = './new-image-editor/';
  }, 5000);

  return true;
}
